import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { SOCIAL_MEDIA } from "common/constants/Constants";
import { BUTTON_THEME_WHITE_LIGHT_FOCUS } from "components/v3/primary-button/themes";

const TerminalSocialButton = ({ onClick }) => {
    const onTerminalClick = () => onClick(SOCIAL_MEDIA.TERMINAL);

    return (
        <div className={ styles.terminalSocialButton }>
            <span className={ styles.message }>Bloomberg Anywhere clients</span>
            <div className={ styles.signInButton }>
                <PrimaryButton
                    type="button"
                    onClick={ onTerminalClick }
                    theme={ BUTTON_THEME_WHITE_LIGHT_FOCUS }
                    text="Sign In Here"
                />
            </div>
        </div>
    );
};

TerminalSocialButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default TerminalSocialButton;
